import { formatDate } from '@/shared/utils/format';
import type { ReferralEvent } from '../api/referralsApi';
import styles from './ReferralTimeline.module.css';

const LABELS: Record<string, string> = {
  created: 'Draft created',
  sent: 'Referral sent',
  recipient_emailed: 'Receiving office emailed',
  recipient_email_failed: 'Email to receiving office failed',
  delivered_to_inbox: 'Delivered to their PracticeNova inbox',
  recipient_texted: 'Receiving office texted the secure link',
  recipient_text_failed: 'Text to receiving office failed',
  printed_copy: 'Printed slip chosen for hand-off',
  patient_text_queued: 'Patient copy handed to the texting agent',
  patient_texted: 'Patient texted a copy',
  patient_text_failed: 'Text to the patient failed (office unaffected)',
  patient_text_skipped: 'Patient text skipped',
  viewed: 'Opened by the receiving office (email verified)',
  scheduled: 'Patient scheduled',
  completed: 'Treatment completed',
  declined: 'Declined',
  cancelled: 'Cancelled',
  report_added: 'Report sent back',
  note_added: 'Note added',
  reminder_sent: 'Reminder sent to the receiving office',
  attachment_added: 'File added',
  office_chosen: 'Office confirmed: the other offices were told the patient went elsewhere',
  unconfirmed: 'No office confirmed within the window',
  outcome_not_seen: 'Front desk: the patient never went',
  patient_followup_sent: 'Patient asked by text whether they booked',
  patient_followup_skipped: 'Text check-in skipped (already settled)',
  patient_replied: 'Patient replied',
  patient_reply_escalated: "Patient's reply needs a human",
};

export function ReferralTimeline({ events }: { events: ReferralEvent[] }) {
  if (events.length === 0) return null;
  return (
    <ol className={styles.list}>
      {[...events].reverse().map((e) => (
        <li key={e.id} className={styles.item}>
          <span className={styles.dot} data-type={e.type} />
          <div className={styles.body}>
            <div className={styles.head}>
              <span className={styles.label}>{LABELS[e.type] ?? e.type.replace(/_/g, ' ')}</span>
              <span className={styles.when}>{formatDate(e.createdAt, 'MMM d, h:mm a')}</span>
            </div>
            {(e.actorName || e.note || typeof e.meta?.office === 'string') && (
              <div className={styles.detail}>
                {typeof e.meta?.office === 'string' && <span className={styles.actor}>{e.meta.office as string}</span>}
                {e.actorName && <span className={styles.actor}>{e.actorName}</span>}
                {e.note && <span className={styles.note}>{e.note}</span>}
              </div>
            )}
            {typeof e.meta?.scheduledFor === 'string' && (
              <div className={styles.detail}>For {formatDate(e.meta.scheduledFor as string, 'EEE, MMM d, yyyy h:mm a')}</div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );
}
